import React from 'react';
import { generateModifierClasses } from "../../modules/utils";
const BlockBody = function ({ children, modifiers }) { return /*#__PURE__*/ React.createElement("div", { className: generateModifierClasses('block__body', modifiers) }, children); };
export default BlockBody;
